import React from 'react'
import { Link } from 'react-router-dom'
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi'
import Logo from '@/components/ui/Logo'

const Footer: React.FC = () => {
    return (
        <footer className="bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-white border-t border-gray-200 dark:border-gray-700">
            <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-8 sm:py-10 md:py-12">
                <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
                    {/* Company Info */}
                    <div className="col-span-2 md:col-span-2 lg:col-span-2">
                        <div className="flex items-center mb-4 sm:mb-6">
                            <Logo
                                size="sm"
                                showText={false}
                                variant="default"
                                backgroundColor="bg-transparent"
                                className="hover:scale-105 transition-transform duration-200"
                            />
                            <span className="ml-2 text-xl sm:text-2xl font-heading font-bold text-gray-800 dark:text-white truncate">
                                SideGO
                            </span>
                        </div>
                        <p className="text-sm sm:text-base md:text-body text-gray-600 dark:text-gray-400 mb-4 sm:mb-6 max-w-md leading-relaxed">
                            The global platform for side hustles and gig work. Connect with opportunities worldwide,
                            build your career, and earn extra income on your terms.
                        </p>
                        <div className="space-y-2 sm:space-y-3 text-sm sm:text-base md:text-body text-gray-600 dark:text-gray-400">
                            <div className="flex items-center min-w-0">
                                <FiMapPin className="w-3 h-3 sm:w-4 sm:h-4 mr-2 sm:mr-3 text-primary-400 flex-shrink-0" />
                                <span className="truncate">Worldwide</span>
                            </div>
                            <div className="flex items-center min-w-0">
                                <FiMail className="w-3 h-3 sm:w-4 sm:h-4 mr-2 sm:mr-3 text-primary-400 flex-shrink-0" />
                                <a href="mailto:devsidego@gmail.com" className="hover:text-primary-600 transition-colors truncate">
                                    devsidego@gmail.com
                                </a>
                            </div>
                            <div className="flex items-center min-w-0">
                                <FiPhone className="w-3 h-3 sm:w-4 sm:h-4 mr-2 sm:mr-3 text-primary-400 flex-shrink-0" />
                                <a href="tel:+233597537575" className="hover:text-primary-600 transition-colors truncate">
                                    +233597537575
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-base sm:text-lg md:text-xl font-heading font-semibold mb-3 sm:mb-4 text-gray-800 dark:text-white">Quick Links</h3>
                        <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base md:text-body text-gray-600 dark:text-gray-400">
                            <li>
                                <Link to="/gigs" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 flex items-center group">
                                    <span className="w-1 h-1 bg-primary-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                    Browse Gigs
                                </Link>
                            </li>
                            <li>
                                <Link to="/how-it-works" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 flex items-center group">
                                    <span className="w-1 h-1 bg-primary-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                    How It Works
                                </Link>
                            </li>
                            <li>
                                <Link to="/categories" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 flex items-center group">
                                    <span className="w-1 h-1 bg-primary-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                    Categories
                                </Link>
                            </li>
                            <li>
                                <Link to="/success-stories" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 flex items-center group">
                                    <span className="w-1 h-1 bg-primary-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                    Success Stories
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 flex items-center group">
                                    <span className="w-1 h-1 bg-primary-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                    Blog
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Support */}
                    <div>
                        <h3 className="text-base sm:text-lg md:text-xl font-heading font-semibold mb-3 sm:mb-4 text-gray-800 dark:text-white">Support</h3>
                        <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base md:text-body text-gray-600 dark:text-gray-400">
                            <li>
                                <Link to="/help" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 flex items-center group">
                                    <span className="w-1 h-1 bg-primary-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                    Browse Help Center
                                </Link>
                            </li>
                            <li>
                                <Link to="/faq" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 flex items-center group">
                                    <span className="w-1 h-1 bg-primary-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                    FAQ
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 flex items-center group">
                                    <span className="w-1 h-1 bg-primary-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                    Contact Support
                                </Link>
                            </li>
                            {/* <li>
                                <Link to="/safety" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 flex items-center group">
                                    <span className="w-1 h-1 bg-primary-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                    Safety Guidelines
                                </Link>
                            </li>
                            <li>
                                <Link to="/dispute" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 flex items-center group">
                                    <span className="w-1 h-1 bg-primary-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                    Dispute Resolution
                                </Link>
                            </li> */}
                        </ul>
                    </div>
                </div>

                {/* Bottom Section */}
                <div className="border-t border-gray-300 dark:border-gray-600 mt-8 sm:mt-10 md:mt-12 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4">
                    <p className="text-sm sm:text-base md:text-body text-gray-600 dark:text-gray-400 text-center md:text-left order-2 md:order-1">
                        © {new Date().getFullYear()} SideGO. All rights reserved.
                    </p>
                    <div className="flex flex-wrap gap-2 sm:gap-3 md:gap-6 text-sm sm:text-base md:text-body text-gray-600 dark:text-gray-400 justify-center md:justify-end order-1 md:order-2">
                        <Link to="/privacy" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                            Privacy Policy
                        </Link>
                        <Link to="/terms" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                            Terms of Service
                        </Link>
                        <Link to="/cookies" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                            Cookie Policy
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer